// Order tracking steps — must match backend server.py TRACKING_STEPS
export const TRACKING_STEPS = [
  "ordered",
  "preparing",
  "handed_to_carrier",
  "shipped",
  "arrived_in_country",
  "out_for_delivery",
  "delivered",
];

export const STEP_LABELS = {
  en: {
    ordered: "Ordered",
    preparing: "Preparing",
    handed_to_carrier: "Handed to carrier",
    shipped: "Shipped",
    arrived_in_country: "Arrived in country",
    out_for_delivery: "Out for delivery",
    delivered: "Delivered",
    cancelled: "Cancelled",
  },
  ar: {
    ordered: "تم الطلب",
    preparing: "قيد التحضير",
    handed_to_carrier: "تم تسليمه للناقل",
    shipped: "تم الشحن",
    arrived_in_country: "وصل إلى البلد",
    out_for_delivery: "خرج للتوصيل",
    delivered: "تم التوصيل",
    cancelled: "ملغى",
  },
};

export const STEP_DESCRIPTIONS = {
  en: {
    ordered: "We received your order.",
    preparing: "Your order is being prepared.",
    handed_to_carrier: "Handed over to the shipping company.",
    shipped: "On its way to you.",
    arrived_in_country: "Cleared customs and arrived in your country.",
    out_for_delivery: "Out for delivery to your address.",
    delivered: "Package delivered.",
    cancelled: "This order was cancelled.",
  },
  ar: {
    ordered: "استلمنا طلبك.",
    preparing: "طلبك قيد التحضير.",
    handed_to_carrier: "تم تسليم الطلب لشركة الشحن.",
    shipped: "الطلب في طريقه إليك.",
    arrived_in_country: "وصل الطلب إلى بلدك.",
    out_for_delivery: "الطلب خرج للتوصيل إلى عنوانك.",
    delivered: "تم توصيل الطلب.",
    cancelled: "تم إلغاء هذا الطلب.",
  },
};

// Return index of the last reached step, or -2 if cancelled, or -1 if none.
export function currentStepIndex(events) {
  let idx = -1;
  for (const e of events || []) {
    if (e.step === "cancelled") return -2;
    const i = TRACKING_STEPS.indexOf(e.step);
    if (i > idx) idx = i;
  }
  return idx;
}
